export const getDriverLog = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
  };
  return { ...state, getDriverLog: { ...state.getDriverLog, ...updateValue } };
};

export const getDriverLogSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, getDriverLog: updateValue };

};

export const getDriverLogFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, getDriverLog: updateValue };
};